import * as React from 'react';

function SvgFacebookMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.015 3.006c1.107-.01 2.214-.004 3.322-.004.004 1.168.004 2.337 0 3.505-.716-.001-1.433.002-2.148-.001-.454-.029-.92.315-1.002.765-.011.782-.004 1.564-.004 2.346 1.05.004 2.1-.002 3.149.002a43.671 43.671 0 01-.382 3.378c-.927.008-1.854-.001-2.782.005-.008 3.335.005 6.67-.006 10.004-1.377.006-2.755-.002-4.132.004-.026-3.335.002-6.672-.014-10.008-.672-.007-1.344.005-2.016-.006.003-1.12 0-2.242.001-3.363.672-.008 1.343.002 2.015-.005.02-1.09-.02-2.18.021-3.27.067-.862.396-1.731 1.04-2.327.781-.743 1.891-.994 2.938-1.025z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgFacebookMono;
